// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__8j9Ma","info":"Panel_info__xHnXL","btns":"Panel_btns__YOyRK","button":"Panel_button__lnZa1"};